<template>
  <div>
    <v-card>
      <v-card-title>
        <div class="headline">GL Budget</div>
      </v-card-title>
      <v-card-text>
        <Progress></Progress>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Progress from '@/components/misc/inProgress'
export default {
  data() {
    return {}
  },
  methods: {},
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.glacctNoId.branch && !vm.glacctNoId.glacctNo) {
        vm.$router.push({ name: 'glAcctNoList' })
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'glAcctNoDet' && to.name !== 'glPostAcct') {
      sessionStorage.removeItem('glacctNo')
    }
    next()
  },
  computed: {
    menu() {
      return this.$store.state.glAcctParam.menu
    },
    glacctNoId() {
      return this.$store.state.glAcctParam.glAcctNo.glAcctNoId
    }
  },
  components: {
    Progress
  }
}
</script>

<style>
</style>
